import styled from 'styled-components';
import * as UI from 'components/modules/UI/ui';

export const Section = styled(UI.Section)`
  justify-content: center;
  align-items: stretch;
  position: relative;
  height: 80vw;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
  @media (min-width: 1024px) {
    height: ${({ height }) => (height ? `${height}vh` : '100vh')};
  }
`;
/* height: 100vh !important; */

export const TextOuterWrapperDesktop = styled.div`
  flex-direction: column;
  flex-grow: 1;
  display: none;
  @media (min-width: 1024px) {
    display: flex;
    flex-direction: column;
    text-align: ${({ textHorizAlign }) => textHorizAlign};
    justify-content: ${({ textAlign }) => textAlign};
  }
`;

export const TextContent = styled(UI.CenterContainer)`
  z-index: 1;
  overflow: visible;
  @media (min-width: 1024px) {
    overflow: visible;
    margin-left: ${({ textHorizAlign }) =>
    UI.marginAlignMap[textHorizAlign] &&
      UI.marginAlignMap[textHorizAlign].marginLeft};
    margin-right: ${({ textHorizAlign }) =>
    UI.marginAlignMap[textHorizAlign] &&
      UI.marginAlignMap[textHorizAlign].marginRight};
  }
`;

export const TextWrapperMobile = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  background-color: ${({ backgroundColor }) => backgroundColor};
  @media (min-width: 1024px) {
    display: none;
  }
`;

export const TextContainerMobile = styled(UI.HalfContainer)`
  @media (max-width: 1023px) {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }
`;



// WEBPACK FOOTER //
// ./src/components/modules/SliderFullscreenSection/styled.js